module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/lamp-c1e09aa2f00214dbedf6632fd4b6a3c7.svg";